export type BrandVariant = "default" | "ecole" | "liceo";

export function formatBrandLanguageLabel(name: string, variant: BrandVariant): string {
  if (variant !== "liceo") return name;
  if (name === "English (United States)") return "English";
  if (name === "Latin American Spanish") return "Spanish";
  return name;
}

export interface AppBrandConfig {
  variant: BrandVariant;
  name: string;
  shareTitle: string;
  shareText: string;
  logoSrc: string;
  animatedLogoSrc?: string | null;
  logoAlt: string;
  logoClassName?: string;
  tagline: string;
  taglineSubtext?: string;
  taglineLinkText?: string;
  taglineLinkHref?: string;
  backgroundMedia?: { videoUrl: string; posterUrl: string };
}

export const DEFAULT_APP_BRAND: AppBrandConfig = {
  variant: "default",
  name: "ChickyTutor",
  shareTitle: "ChickyTutor - AI Speaking Practice",
  shareText: "Practice speaking with a private AI language tutor and get useful corrections.",
  logoSrc: "/ui/brand-kit/lockups/chickytutor-lockup-horizontal-dark-1080.png",
  animatedLogoSrc: null,
  logoAlt: "ChickyTutor",
  logoClassName: "h-20 md:h-24 lg:h-42 xl:h-48 inline-block md:block drop-shadow-2xl",
  tagline: "A tutor that knows you better every day.",
};

export const ECOLE_APP_BRAND: AppBrandConfig = {
  variant: "ecole",
  name: "L'ecole de francais",
  shareTitle: "L'ecole de francais - AI French Practice",
  shareText: "Practice French with the L'ecole de francais experience powered by Chickytutor.",
  logoSrc: "/ui/ecole.png",
  logoAlt: "L'ecole de francais",
  logoClassName: "h-20 md:h-24 lg:h-28 xl:h-32 w-auto inline-block md:block drop-shadow-2xl",
  tagline: "French practice, taught the right way by L'ecole de francais",
  taglineSubtext: "powered by",
  taglineLinkText: "ChickyTutor",
  taglineLinkHref: "https://www.chickytutor.com",
};

export const LICEO_APP_BRAND: AppBrandConfig = {
  variant: "liceo",
  name: "Liceo Cultural Británico",
  shareTitle: "Liceo Cultural Británico | Práctica de inglés",
  shareText: "Practicá inglés entre clases con Liceo Cultural Británico y ChickyTutor.",
  logoSrc: "/ui/liceoculturalbritanicologo.png",
  logoAlt: "Liceo Cultural Británico — Sabemos cómo enseñar",
  tagline: "Practicá inglés con confianza, también entre clases.",
  taglineSubtext: "powered by",
  taglineLinkText: "ChickyTutor",
  taglineLinkHref: "https://www.chickytutor.com",
  backgroundMedia: {
    videoUrl: "/ui/ecole-ping-pong.mp4",
    posterUrl: "/ui/ecole-ping-pong-poster.webp",
  },
};
